import React from "react";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";

const NoDataCommonCard = ({
  onClick,
  title,
  description,
  buttonText,
  image,
}) => {
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <div className="drop-shadow rounded-2xl bg-white dark:bg-gray-900 border dark:border-gray-800 w-[420px] h-fit p-9 flex flex-col gap-4 items-center justify-center">
        <div className="flex flex-col gap-4 items-center justify-center">
          <div className="flex flex-col gap-2 items-center justify-center">
            <img src={image} alt="no data" className="w-16 h-16" />
            <h4 className="text-[1.02rem] font-bold text-gray-900 dark:text-gray-100">{title}</h4>
            <p className="text-[0.85rem] text-gray-500 dark:text-gray-400 text-center">
              {description}
            </p>
          </div>
          <PrimaryButton onClick={onClick}>{buttonText}</PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default NoDataCommonCard;
